import classes from '@/components/Shares/Input.module.css';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBlack } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Button, Group, Stack, Text, TextInput } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { AuthModalLayout } from './AuthModalLayout';
import { SendLinkButton } from './SendLinkButton';
export const ForgotPassword: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  return <AuthModalLayout opened={openModal === MODAL.FORGOT} handleClose={() => setOpenModal(null)}>
      <Stack gap={10} mx="auto" w={{
      base: '100%',
      sm: 524,
      xl: 427
    }}>
        <Button size="xs" mb={20} variant="transparent" c="var(--text-dark)" tt="uppercase" leftSection={<IconArrowLeft size={20} />} onClick={() => setOpenModal(MODAL.LOGIN)}>
          {i18n._('Return')}
        </Button>

        <Text component="h2" fz="h2" ta="center" tt="uppercase" c="var(--text-prime)" className={gunterzBlack.className}>
          {i18n._('Forgot Password')}
        </Text>
        <Group justify="center">
          <Text tt="uppercase" ta="center" fz="xs" fw={700} w={{
          base: '80%',
          sm: '70%',
          md: '80%'
        }} c="var(--text-dark)">
            {i18n._('Enter your email to reset your path and get back into the game!')}
          </Text>
        </Group>

        <TextInput mt={20} radius="sm" placeholder="Email" size="md" classNames={{
        input: classes.input_style_2
      }} />

        <SendLinkButton />
      </Stack>
    </AuthModalLayout>;
};